export default __webpack_public_path__ + "static/media/group-2.d2903111.png";